/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";

import {
  CardContent,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
import { BTable } from "components/BTable/BTable";
import TimelineItem from "components/Icon/TimelineItem";
import LoadingModal from "components/LoadingModel/loadingModal";
import MDButton from "components/MDButton";
import ViewCard from "components/ViewCard/ViewCard";
import CustomText from "components/customtext/customtext";
import DeleteModal from "components/deletemodal/deletemodal";
import DisplayModal from "components/displayModel/displayModel";
import Height from "components/height/height";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { deleteAddressByID, deleteOrderItemsByID, editOrderforfinal, getAddress, getOrderChargesByID, getOrderItems, getWarehouseByID, saveOrder, saveOrderItems, updateOrderDetailsByID, updateOrderItemsByID } from "utils/api";
import { blank, generateDataList, getScreenRight, showResMsg, validateField } from "utils/generic";
import { genericMessage } from "utils/genericMessages";

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};


function NewOrders() {
  const { id } = useParams();
  const [rows, setRows] = useState([]);
  const screenName = "Add New Order";
  const [wareHouseName, setwarehouseName] = useState("")
  const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState([]);
  const [customerPickAddress, setCustomerPickAddress] = useState([]);
  const [customerDeliveryAddress, setCustomerDeliveryAddress] = useState([]);
  const [selected, setSelectedValue] = useState("");
  const [deleteAddressDialogeFlag, setDeleteAdressDialogeFlag] = useState(false);
  const [cargoTypeErr, setcargoTypeErr] = useState(false);
  const [cargoTemperatureErr, setcargoTemperatureErr] = useState(false);
  const [numberOfItemsErr, setnumberOfItemsErr] = useState(false);
  const [lengthErr, setlengthErr] = useState(false);
  const [breadthErr, setbreadthErr] = useState(false);
  const [heightErr, setheightErr] = useState(false);
  const [WeightErr, setWeightErr] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [warehouseErr, setWaehouseErr] = useState(false);
  const [displayDialogeFlag, setDisplayDialogeFlag] = useState(false);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [itemEditFlag, setItemEditFlag] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const [customReload, setCustomReload] = useState(false);
  const dispatch= useDispatch()
  const navigate = useNavigate()
 
  
  const [values, setValues] = React.useState({
    cargoType: "Chiller",
    numberOfItems: "",
    cargoTemperature: "",
    lengthInMm: "",
    breadthInMm: "",
    heightInMm: "",
    weightInKg: "",
    description: "",
    orderStatus: "",
    orderID: "",
    customerID: "",
    itemDescription: 'PLT–Pallet',
    pickupWarehouseID: "",
    shipmentType: "Sender Location Pickup",
    businessUserID: (JSON.parse(sessionStorage.getItem('LOGIN_DETAILS')).businessUserID),
    senderAddressID: "",
    receiverAddressID: "",

  });


  const handleChange = (name) => (event) => {
    if (event.target.validity !== undefined && event.target.validity.valid === true) {
      setValues({ ...values, [name]: event.target.value });
    }
    else if (event.target.validity === undefined) {
      setValues({ ...values, [name]: event.target.value });
    }
  };




  sessionStorage.removeItem("ORDER_ROUTE");

  const addRedirect = async (val) => {
    if (values.customerID !== "" && values.customerID !== undefined) {
      sessionStorage.setItem("ORDER_ROUTE", window.location.pathname);
      sessionStorage.setItem("CUSTOMERID", values.customerID);
      navigate(`/addAddress/${values.customerID}?type=${val}`);
    } else {
      showResMsg( genericMessage.selectCustomer , 1000, false);
    }
  };
  const customerRedirect = async () => {
    sessionStorage.setItem("CUSTOMERID", values.customerID);
    navigate(`/customers/addNewCustomer?add=1`)
    
  };
  const editAddress = async (val) => {
    sessionStorage.setItem("CUSTOMERID", values.customerID);
    sessionStorage.setItem("ORDER_ROUTE", window.location.pathname);
    navigate(`/editAddress/${val}`)
    

  };


  useEffect(() => {
    (async()=>{
     await Promise.all([
        getRight(),
        fetchAddressAndCustomer(),
        fetchWarehouseName()
      ])
      if (id !== undefined && id !== "") {
       await Promise.all([
          fetchOrderByID(),
          fetchOrderItems()
        ])
      }
    })()  
  }, [id,customReload])
  
  useEffect(() => {
    if (sessionStorage.getItem('CUSTOMERID') !== null && sessionStorage.getItem('CUSTOMERID') !== "" && sessionStorage.getItem('CUSTOMERID') !== undefined) {
      values.customerID = sessionStorage.getItem('CUSTOMERID')
      sessionStorage.removeItem("CUSTOMERID");
    }
    let pickupAddress = []
    let diliveryAddress = []
    customer.map(val => {
      if (val._id === values.customerID) {
        val.address.map(address => {
          if (address.addressCategory === "Pickup") {
            pickupAddress.push(address)
          } else {
            diliveryAddress.push(address)
          }

        })
      }
    })
    if (pickupAddress.length > 0) {
      values.senderAddressID = pickupAddress[0]._id
    }
    if (diliveryAddress.length > 0) {
      values.receiverAddressID = diliveryAddress[0]._id
    }
    setCustomerPickAddress(pickupAddress)
    setCustomerDeliveryAddress(diliveryAddress)

  }, [values.customerID, customer])



 
  async function getRight() {
    let right = await getScreenRight("Orders")
    if (right === "Full Access") {
      setDisableColor(false)
    }
    else setDisableColor(true)

  }
  useEffect(() => {
    if (values.shipmentType === "Sender Location Pickup") {
      values.pickupWarehouseID = ""
    }

  }, [values.shipmentType])

  const fetchAddressAndCustomer = async () => {
    getAddress(values ,(data)=>{
      if (data.Result_Status) 
        setCustomer(data.Result_Output)
    },dispatch)
   
  };
  const fetchWarehouseName = async () => {
    getWarehouseByID(values, async(data)=>{
      if (data.Result_Output.length > 0) {
        setwarehouseName(await generateDataList(data.Result_Output, "_id", "warehouseName"))
      }
    },dispatch)
  }

  const clearErrorStates = () => {
    setWaehouseErr(false);
    setcargoTypeErr(false);
    setnumberOfItemsErr(false);
    setlengthErr(false);
    setbreadthErr(false);
    setheightErr(false);
    setWeightErr(false);
  };

  let mandateFlag;
  const addOrder = async () => {
    mandateFlag = false;
   
    clearErrorStates()
    if (values.cargoType === "Chiller") {
      values.cargoTemperature = 3
    } else if (values.cargoType === "Freezer") {
      values.cargoTemperature = -18
    } else {
      values.cargoTemperature = ""
    }
    if (values.senderAddressID.toString().trim() === "") {
      showResMsg(genericMessage.senderAddressErr, 2000, false)
      return
    }
    if (values.receiverAddressID.toString().trim() === "") {
      showResMsg(genericMessage.recieverAddressErr, 2000, false)
      return
    }
    if (values.shipmentType === "drop at Warehouse") {
      mandateFlag = validateField(values.pickupWarehouseID, setWaehouseErr) || mandateFlag;
    }
    if (
      id !== "" &&
      id !== undefined &&
      (
        (values.numberOfItems === "" || values.numberOfItems === undefined) &&
        (values.lengthInMm === "" || values.lengthInMm === undefined) &&
        (values.breadthInMm === "" || values.breadthInMm === undefined) &&
        (values.weightInKg === "" || values.weightInKg === undefined)
      )
    ) {
      if (!mandateFlag) {
        updateOrderDetailsByID(values,(data)=>{
          if(data.Result_Status){
            data.Result_Output.cargoType = "Chiller"
                setValues(data.Result_Output)
          } 
          showResMsg(data.Result_Status ? genericMessage.orderUpdateMsg : data.Result_Message, 1000, data.Result_Status  );
        },dispatch)
      }
      return
    }

    mandateFlag = validateField(values.cargoType, setcargoTypeErr) || mandateFlag;
    mandateFlag = validateField(values.numberOfItems, setnumberOfItemsErr) || mandateFlag;
    mandateFlag = validateField(values.lengthInMm, setlengthErr) || mandateFlag;
    mandateFlag = validateField(values.breadthInMm, setbreadthErr) || mandateFlag;
    mandateFlag = validateField(values.heightInMm , setheightErr) || mandateFlag;
    mandateFlag = validateField(values.weightInKg , setWeightErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    if(id!== undefined) values.orderID = id
    const apiFunction = id === undefined || id === "" ? saveOrder : saveOrderItems;
    apiFunction(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined || id === "" ? genericMessage.orderAdded : genericMessage.orderItemAdded, 1000, data.Result_Status, navigate,id === undefined || id === ""? navigate(`/orders/editOrder/${data.Result_Output.orderID}`):"");
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
      if(id !== undefined || id !== ""){
        setValues((prevValues) => ({
          ...prevValues,
          cargoType: "",
          numberOfItems: "",
          cargoTemperature: "",
          description: "",
          weightInKg: "",
          lengthInMm: "",
          breadthInMm: "",
          heightInMm: "",
        }));
       
      }
      fetchOrderItems()
    }, dispatch);


  }
  const editOrderItem = async () => {
    mandateFlag = false;
    clearErrorStates()

    mandateFlag = validateField(values.cargoType, setcargoTypeErr) || mandateFlag;

    if (values.cargoType === "Chiller" || values.cargoType === "Freezer") {
      if (values.cargoTemperature === "" || values.cargoTemperature === undefined) {
        setcargoTemperatureErr(true);
        mandateFlag = true;
      } else setcargoTemperatureErr(false);
    } else {
      setcargoTemperatureErr(false);
    }
    mandateFlag = validateField(values.numberOfItems, setnumberOfItemsErr) || mandateFlag;
    mandateFlag = validateField(values.lengthInMm, setlengthErr) || mandateFlag;
    mandateFlag = validateField(values.breadthInMm, setbreadthErr) || mandateFlag;
    mandateFlag = validateField(values.heightInMm , setheightErr) || mandateFlag;
    mandateFlag = validateField(values.weightInKg , setWeightErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    updateOrderItemsByID(values,(data)=>{
      showResMsg(genericMessage.orderItemUpdated, 2000, data.Result_Status)
      if(data.Result_Status){
        setValues((prevValues) => ({
          ...prevValues,
          cargoType: "",
          numberOfItems: "",
          cargoTemperature: "",
          description: "",
          weightInKg: "",
          lengthInMm: "",
          breadthInMm: "",
          heightInMm: "",
        }));
        fetchOrderItems()
        setItemEditFlag(false)
      }

    },dispatch)
   
  }



  const fetchOrderItems = async () => {
    getOrderItems({ orderID: id } , (data)=>{
      if (data.Result_Output.length > 0) {
        setRows(data.Result_Output)
      }else{
        setRows([])
      }
    },dispatch)

  }
  const fetchOrderByID = async () => {
    editOrderforfinal({ orderID: id } , (data)=>{
      data.Result_Output.cargoType = "Chiller"
      data.Result_Output.itemDescription = 'PLT–Pallet'
          setValues(data.Result_Output)

    }, dispatch)
 
  }
  const handleDisplayDialogeClick = async (_id) => {
    if (rows.length === 0) {
      showResMsg(genericMessage.addAtleastOneOrder, 2000, false)
      return;
    } else {
      setSelectedId(_id);
      setDisplayDialogeFlag(!displayDialogeFlag);
    }

  };

  const handleCancel1 = name => event => {
    setDisplayDialogeFlag(false);
  };
  const handleCancel = name => event => {
    setDeleteDialogeFlag(false);
    setDeleteAdressDialogeFlag(false);
  };
  const handleDisplay = async (id) => {
    getOrderCharges();
    setDisplayDialogeFlag(!displayDialogeFlag);
  };
  const handleEditItemsClick = async (_id) => {

    rows.map(item => {
      if (item._id === _id) {
        setItemEditFlag(true)
        setValues((prevValues) => ({
          ...prevValues,
          cargoType: item.cargoType,
          numberOfItems: item.numberOfItems,
          cargoTemperature: item.cargoTemperature,
          description: item.description,
          weightInKg: item.weightInKg,
          lengthInMm: item.lengthInMm,
          breadthInMm: item.breadthInMm,
          heightInMm: item.heightInMm,
        }));

      }
    })
    values._id = _id
  }
  const handleDeleteDialogeClick = async (_id) => {
    values.id = _id
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };
  const handleDeleteDialogeClick1 = async (_id) => {
    values.id = _id
    setDeleteAdressDialogeFlag(!deleteAddressDialogeFlag);
  };

  const handleDelete = async () => {
    deleteOrderItems();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };
  const deleteOrderItems = async () => {
    deleteOrderItemsByID({id:values.id} ,(data)=>{
      if(data.Result_Status) setCustomReload(!customReload)
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status );
    },dispatch)
  };
  const handleDeleteAddress = async () => {
    deleteAddress();
    setDeleteAdressDialogeFlag(!deleteAddressDialogeFlag);
  };

  const deleteAddress = async () => {
    deleteAddressByID(values , (data)=>{
      if(data.Result_Status) setCustomReload(!customReload)
      showResMsg(data.Result_Status ? genericMessage.deleted : data.Result_Message, 1000, data.Result_Status );
    },dispatch)
  };



  const getOrderCharges = async () => {
    if (rows.length === 0) {
      showResMsg( genericMessage.addAtleastOneOrder , 1000, false );
      return;
    }
    getOrderChargesByID({ orderID: id, orderStatus: values.orderStatus, businessUserID: values.businessUserID },(data)=>{
      showResMsg(data.Result_Status ? genericMessage.orderFinalize : data.Result_Message, 1000, data.Result_Status, navigate, '/orders');
    },dispatch)
  }


  let CustomerList =
    customer.length > 0 &&
    customer.map((item, i) => {
      let name;
      if (item.businessName !== "" && item.businessName !== undefined) {
        name = item.businessName
      } else {
        name = item.firstName + " " + item.lastName
      }
      return (
        <MenuItem key={i} value={item._id}>
          {name} ({item.phoneNumber})
        </MenuItem>
      );
    }, this);

   
   const itemCol=[
    {
      name: "Cargo Type",
      selector: row => row.cargoType,
      sortable: true,
      sortField: 'cargoType',
    },
    {
      name: "Temperature (c)",
      selector: row => row.cargoTemperature,
      sortable: true,
      sortField: 'cargoTemperature',
    },

    {
      name: "Number of Items",
      selector: row => row.numberOfItems,
      sortable: true,
      sortField: 'numberOfItems',
    },

    {
      name: "Item Description",
      selector: row => row.description,
      sortable: true,
      sortField: 'description',
    },

    {
      name: "Weight (kg.)",
      selector: row => row.weightInKg,
      sortable: true,
      sortField: 'weightInKg',
    },

    {
      name: "Dimension (m3)",
      selector: row => row.lengthInMm + "*" + row.breadthInMm + "*" + row.heightInMm,
      sortable: true,
     
    },
    {
      name: "Actions",
      selector: row => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}>
          {disableColor ? <><Grid item>
              <TimelineItem
                color="grey"
                icon="edit"
                title="Edit"
              />

            </Grid></> : <><Grid item>

              <TimelineItem
                color="success"
                icon="edit"
                title="Edit"
                onClick={() => handleEditItemsClick(row._id)}
              />

            </Grid></>}

            {disableColor ? <>  <Grid item>
              <TimelineItem
                color="grey"
                icon="delete"
                title="Delete Items"
              />
            </Grid></> : <>  <Grid item>
              <TimelineItem
                color="error"
                icon="delete"
                onClick={() => handleDeleteDialogeClick(row._id)}
                title="Delete Items"
              />
            </Grid></>}
          </Grid>

        </>
      ),
    },



   ]
  


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <PageTitle screenName={screenName} />
        <Grid container px={3} py={3} columnGap={4}>
          <Grid item lg={2.5}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Customer</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                name="userType"
                id="demo-simple-select"
                style={{ minHeight: "44.11px" }}
                label="Customer"
                autoFocus={true}
                disabled={itemEditFlag}
                value={values.customerID}
                onChange={handleChange("customerID")}
              >
                {CustomerList}
              </Select>
            </FormControl>
          </Grid>
          <Grid item lg={0.5} pt={0.5}>
            <TimelineItem color="info" icon="add" title="Add New Customer" onClick={customerRedirect} height="2rem" width="2rem" fontSize="small" />
            {/* <Add  /> */}
          </Grid>
          <Grid item xs={1.2} pl={0}>
            {" "}
            <FormLabel id="demo-row-radio-buttons-group-label" sx={{ fontSize: "16px" }}>
              Shipment Type:
            </FormLabel>
          </Grid>
          <Grid item xs={3.5}>
            <FormControl>
              <RadioGroup
                row
                // disabled = {id !== undefined && id !== "" ?true:false}
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={values.shipmentType}
                onChange={handleChange("shipmentType")}
              >
                <FormControlLabel
                  className="radio"
                  value="Sender Location Pickup"
                  control={<Radio />}
                  disabled={itemEditFlag}
                  label="Location Pickup"
                />
                <FormControlLabel
                  className="radio"
                  value="drop at Warehouse"
                  control={<Radio />}
                  disabled={itemEditFlag}
                  label="Drop at Warehouse"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {values.shipmentType === "drop at Warehouse" && (
            <Grid item lg={2.8} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select">Select Warehouse</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ minHeight: "44.11px" }}
                  label="Select Warehouse"
                  disabled={itemEditFlag}
                  value={values.pickupWarehouseID}
                  onChange={handleChange("pickupWarehouseID")}
                >
                  {wareHouseName}
                </Select>
                {warehouseErr ? <span style={errMsg}>Warehouse can't be blank</span> : ""}
              </FormControl>
            </Grid>
          )}
        </Grid>
        <Grid container px={3} py={3} columpacing={4}>
          <Grid item lg={5.98} px={2}>
            <Grid item lg={12}>
              <Grid container>
                <Grid item lg={10}>
                  <CustomText type="h3" size={15}>
                    {values.shipmentType === "drop at Warehouse" ?
                      <>
                        Sender Address
                      </> : <>Sender Pickup Address</>
                    }

                  </CustomText>
                </Grid>
                <Grid item lg={2}>
                  <TimelineItem color="info" icon="add" title="Add Sender Address"
                    onClick={() => addRedirect("Pickup")} height="2rem" width="2rem" fontSize="small" />
                  {/* <Add  /> */}
                  {/* <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                >
                 Add New
                </MDButton> */}
                </Grid>
              </Grid>
            </Grid>

            <Height val={20} />
            <Grid container spacing={2} style={{ height: "250px", overflow: "auto" }}>

              {customerPickAddress.map((val, i) => (

                <Grid item lg={6} px={2}>
                  <ViewCard sx={{ padding: "10px" }}  >
                    <Grid container>
                      <Grid item lg={1.5} style={{ display: "flex", alignItems: "center" }}>
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name={`row-radio-buttons-group-${val._id}`}

                            onChange={handleChange("senderAddressID")}
                            value={values.senderAddressID}
                          // value={selected}
                          // onChange={handleChange3}
                          >
                            <FormControlLabel className="radio" value={val._id} control={<Radio />} label="" disabled={itemEditFlag} />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item lg={9} >
                        <CustomText type="h3" size={15} >
                          {val.contactName}
                        </CustomText>
                        <CustomText type="p" size={15} >
                          {val.streetAddress}
                        </CustomText>
                        <CustomText type="p" size={15} >
                          {val.zipCode}
                        </CustomText>
                        <CustomText type="p" size={15} >
                          {val.phoneNumber}
                        </CustomText>
                      </Grid>
                      <Grid item style={{ marginLeft: "-40px" }}>
                        <TimelineItem color="error"
                          icon="delete" title="Delete" onClick={() => handleDeleteDialogeClick1(val._id)} />
                      </Grid>
                      <Grid item style={{ marginLeft: "-30px" }}>
                        <TimelineItem color="success"
                          icon="edit" title="Edit" onClick={() => editAddress(val._id)} />
                      </Grid>
                    </Grid>
                  </ViewCard>
                </Grid>

              ))}
            </Grid>
          </Grid>
          <hr />
          <Grid item lg={5.98} px={2}>
            <Grid item lg={12}>
              <Grid container>
                <Grid item lg={10}>
                  <CustomText type="h3" size={15}>
                    Receiver Address
                  </CustomText>
                </Grid>
                <Grid item lg={2}>
                  <TimelineItem color="info" icon="add" title="Add Receiver Address" onClick={() => addRedirect("Delivery")} height="2rem" width="2rem" fontSize="small" />
                  {/* <Add  /> */}

                  {/* <MDButton
                  className="btn-block center-container-btn btn-warning btn-back rightSpace"
                  color="warning"
                  fullWidth
                >
                 Add New
                </MDButton> */}
                </Grid>
              </Grid>
            </Grid>
            <Height val={20} />
            <Grid container columnSpacing={2} rowGap={2} style={{ height: "250px", overflow: "auto" }}>
              {/* <Grid item lg={6}>
                <Card>asdfsdsdf</Card>
              </Grid> */}
              {customerDeliveryAddress.map((val, i) => (
                <Grid item lg={6} px={2}>
                  <ViewCard sx={{ padding: "10px" }}>
                    <Grid container>
                      <Grid item lg={1.5} style={{ display: "flex", alignItems: "center" }}>
                        <FormControl>
                          <RadioGroup
                            row

                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name={`row-radio-buttons-group-${val._id}`}
                            onChange={handleChange("receiverAddressID")}
                            value={values.receiverAddressID}
                          >
                            <FormControlLabel className="radio" value={val._id} control={<Radio />} label="" disabled={itemEditFlag} />
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      <Grid item lg={9}>
                        <CustomText type="h3" size={15}  >
                          {val.contactName}
                        </CustomText>
                        <CustomText type="p" size={15} >
                          {val.streetAddress}
                        </CustomText>
                        <CustomText type="p" size={15} >
                          {val.zipCode}
                        </CustomText>
                        <CustomText type="p" size={15} >
                          {val.phoneNumber}
                        </CustomText>

                      </Grid>
                      <Grid item style={{ marginLeft: "-40px" }}>
                        <TimelineItem color="error"
                          icon="delete" title="Delete" onClick={() => handleDeleteDialogeClick1(val._id)} />
                      </Grid>
                      <Grid item style={{ marginLeft: "-30px" }}>
                        <TimelineItem color="success"
                          icon="edit" title="Edit" onClick={() => editAddress(val._id)} />
                      </Grid>
                    </Grid>
                  </ViewCard>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        <Grid container columnSpacing={5} px={3} py={3}>

          <Grid item xs={12} lg={2}>
            <FormControl fullWidth>
              <InputLabel id="userStatus">Cargo Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ height: "44.13px" }}
                label="Cargo Type"
                value={values.cargoType}
                onChange={handleChange("cargoType")}

              >
                <MenuItem value="Chiller">Chiller </MenuItem>
                <MenuItem value="Dangerous">Dangerous </MenuItem>
                <MenuItem value="Bulk">Bulk </MenuItem>
                <MenuItem value="Freezer">Freezer</MenuItem>
                <MenuItem value="Dry Goods">Dry Goods</MenuItem>
              </Select>
              {cargoTypeErr ? <span style={errMsg}>Cargo Type can't be blank</span> : ""}
            </FormControl>
          </Grid>
          {(values.cargoType === "Dangerous" || values.cargoType === "Bulk" || values.cargoType === "Dry Goods")
            &&
            <Grid item xs={12} lg={2}>
              <FormControl fullWidth>
                <InputLabel id="userStatus">Cargo Temperature</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ minHeight: "3em" }}
                  label="Cargo Temperature"
                  disabled
                  value={values.cargoTemperature}
                  onChange={handleChange("cargoTemperature")}

                >

                </Select>
              </FormControl>
            </Grid>}
          {values.cargoType === "Chiller"
            &&
            <Grid item xs={12} lg={2}>
              <MDBox component="form" role="form">
                <MDBox mb={4}>
                  <TextField
                    type="text"
                    label="Cargo Temperature"
                    variant="outlined"
                    fullWidth
                    readOnly={true}
                    value={3}
                  />
                  {cargoTemperatureErr ? <span style={errMsg}>Cargo Temperature can't be blank</span> : ""}
                </MDBox>
              </MDBox>

            </Grid>}
          {values.cargoType === "Freezer"
            &&
            <Grid item xs={12} lg={2}>
              <MDBox component="form" role="form">
                <MDBox mb={4}>
                  <TextField
                    type="text"
                    label="Cargo Temperature"
                    variant="outlined"
                    fullWidth
                    readOnly={true}
                    value={-18}
                  />
                  {cargoTemperatureErr ? <span style={errMsg}>Cargo Temperature can't be blank</span> : ""}
                </MDBox>
              </MDBox>

            </Grid>}
          {/*
               <Grid item xs={12} lg={2}>
                <MDBox component="form" role="form">
              <MDBox mb={4}>
                <TextField
                  type="numeric"
                  label="Cargo Temperature"
                  variant="outlined"
                  fullWidth
                  disabled={values.cargoType === "Chiller" || values.cargoType === "Freezer" ? false : true}
                  inputProps={{
                    pattern: "^-?[0-9]*\\.?[0-9]+$", // Allow negative numbers
                  }}
                  value={values.cargoTemperature}
                  onChange={handleChange("cargoTemperature")}
                />
                {cargoTemperatureErr ? <span style={errMsg}>Cargo Temperature can't be blank</span> : ""}
              </MDBox>
            </MDBox>
            </Grid> */}
          <Grid item xs={12} lg={2}>
            <MDBox component="form" role="form">
              <MDBox mb={4}>
                <TextField
                  type="text"
                  label="Number of Items"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    pattern: "^[0-9]+$",
                    maxLength: 5
                  }}
                  value={values.numberOfItems}
                  onChange={handleChange("numberOfItems")}
                />
                {numberOfItemsErr ? <span style={errMsg}>Number of items can't be blank</span> : ""}
              </MDBox>
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={2}>
            <MDBox component="form" role="form">
              <MDBox mb={4}>
                <TextField
                  type="text"
                  label="Item Length (mm)"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    pattern: "^[0-9.]+$",
                    maxLength: 5
                  }}
                  value={values.lengthInMm}
                  onChange={handleChange("lengthInMm")}

                />
                {lengthErr ? <span style={errMsg}>Item length can't be blank</span> : ""}
              </MDBox>
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={2}>
            <MDBox component="form" role="form">
              <MDBox mb={4}>
                <TextField
                  type="text"
                  label="Item Width (mm)"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    pattern: "^[0-9.]+$",
                    maxLength: 5
                  }}
                  value={values.breadthInMm}
                  onChange={handleChange("breadthInMm")}
                />
                {breadthErr ? <span style={errMsg}>Item Width  can't be blank</span> : ""}
              </MDBox>
            </MDBox>
          </Grid>

          <Grid item xs={12} lg={2}>
            <MDBox component="form" role="form">
              <MDBox mb={4}>
                <TextField
                  type="text"
                  label="Item Height (mm)"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    pattern: "^[0-9.]+$",
                    maxLength: 5
                  }}
                  value={values.heightInMm}
                  onChange={handleChange("heightInMm")}
                />
                {heightErr ? <span style={errMsg}>Item Height can't be blank</span> : ""}
              </MDBox>
            </MDBox>
          </Grid>
          <Grid item xs={12} lg={2}>
            <MDBox component="form" role="form">
              <MDBox mb={4} >
                <TextField
                  type="text" id="inputTest"
                  label="Item Weight (Kg.)"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    pattern: "^[0-9.]+$",
                    maxLength: 5
                  }}
                  value={values.weightInKg}
                  onChange={handleChange("weightInKg")}
                />
                {WeightErr ? <span style={errMsg}>Item Weight  can't be blank</span> : ""}
              </MDBox>
            </MDBox>
          </Grid>


          <Grid item xs={12} lg={2}>
            <FormControl fullWidth>
              <InputLabel id="userStatus">Item Description</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                style={{ height: "44.13px" }}
                label="Item Description"
                value={values.itemDescription}
                onChange={handleChange("itemDescription")}

              >
                <MenuItem value="PLT–Pallet">PLT–Pallet</MenuItem>
                <MenuItem value="CTN-Carton">CTN-Carton</MenuItem>
                <MenuItem value="SKD-Skid">SKD-Skid </MenuItem>
                <MenuItem value="PK-Pack">PK-Pack</MenuItem>
                <MenuItem value="BDL-Bundle">BDL-Bundles</MenuItem>
              </Select>
            </FormControl>
          </Grid>


          <Grid item xs={12} lg={4}>
            <MDBox component="form" role="form">
              <MDBox mb={4}>
                <TextField
                  type="text"
                  label="Product Description"
                  id="inputTest"
                  variant="outlined"
                  fullWidth
                  inputProps={{
                    pattern: "^[a-zA-Z0-9 ]+$",
                    maxLength: 500
                  }}
                  value={values.description}
                  onChange={handleChange("description")}


                />
              </MDBox>

            </MDBox>
          </Grid>
        </Grid>
        <Grid
          container
          columnSpacing={4}
          alignItems="center"
          display="flex"
          justifyContent="center"
          pb={4}
        >
          <Grid item xs={12} md={4} spacing={2} lg={1.2}>
            <Link to={"/orders"}>
              <MDButton
                className="btn-block center-container-btn btn-warning btn-back rightSpace"
                color="warning"
                fullWidth
              >
                Cancel
              </MDButton>
            </Link>
          </Grid>
          <Grid item xs={12} md={4} lg={1.2}>
            <MDButton rel="noreferrer" variant="gradient" className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"} fullWidth
              onClick={disableColor ? blank : itemEditFlag ? editOrderItem : addOrder}
            >
              {itemEditFlag ?
                <>
                  Update Item
                </>
                : <>
                  Save
                </>}



            </MDButton>
          </Grid>
          <Grid item xs={12} md={4} lg={1.2}>
            <MDButton rel="noreferrer" variant="gradient" className={"btn-block center-container-btn btn-warning btn-back rightSpace"}
              color={disableColor ? "secondary" : "success"}fullWidth
              onClick={disableColor?blank:handleDisplayDialogeClick}
            >
              Finalize
            </MDButton>
          </Grid>

        </Grid>

        <CardContent>
              <BTable
                columns={itemCol}
                data={rows}
                selectableRows={false}
                fixedHeaderScrollHeight="410px"
                fixedHeader={true}

              /></CardContent>
       
        <MDBox px={2}></MDBox>
      </Card>
      <DisplayModal
        open={displayDialogeFlag}
        handleDelete={handleDisplay}
        handleCancel={handleCancel1("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <DeleteModal
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <DeleteModal
        open={deleteAddressDialogeFlag}
        handleDelete={handleDeleteAddress}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      <LoadingModal loading={loading} />
    </DashboardLayout>
  );
}

export default NewOrders;
